<section class="pt-3 pb-3 page-info section-padding border-bottom bg-white">
  <div class="container">
    <div class="row">
      <div class="col-md-12" style="direction: rtl;">
        <!--        <a href="#"><strong><span class="mdi mdi-home"></span> Home</strong></a> <span class="mdi mdi-chevron-right"></span> <a href="#">Fruits & Vegetables</a> <span class="mdi mdi-chevron-right"></span> <a href="#">Fruits</a>-->
        <app-nav-header [product]="productObj"></app-nav-header>
      </div>
    </div>
  </div>
</section>
@if (productObj != undefined) {
  <section class="shop-single section-padding pt-3">
    <div class="container">
      <div class="row">
        <div class="col-md-6">
          @if (media.length) {
            <div class="shop-detail-slider">
              <div class="favourite-icon">
                <a aria-label="שמירה במועדפים" class="fav-btn" href="#">
                  <i class="far fa-bookmark"></i><i class="mdi mdi-tag-outline"></i>
                </a>
              </div>
              <!-- MAIN -->
              <div class="main-view">
                <button class="nav-btn prev" type="button" (click)="prev()" [disabled]="media.length <= 1">‹</button>
                <div class="main-frame" (touchstart)="onTouchStart($event)" (touchend)="onTouchEnd($event)">
                  @switch (media[currentIndex]?.kind) {
                    @case ('image') {
                      <img
                        class="main-img"
                        [src]="media[currentIndex].url"
                        alt="">
                    }
                    @case ('video') {
                      <video
                        class="main-video"
                        controls
                        muted
                        playsinline
                        preload="metadata">
                        <source [src]="media[currentIndex].url" type="video/mp4" />
                      </video>
                    }
                  }
                </div>
                <button class="nav-btn next" type="button" (click)="next()" [disabled]="media.length <= 1">›</button>
              </div>
              <!-- THUMBS -->
              @if (media.length > 1) {
                <div class="thumbs">
                  @for (m of media; track m; let i = $index) {
                    <button
                      class="thumb"
                      type="button"
                      (click)="goTo(i)"
                      [class.active]="i === currentIndex"
                      [attr.aria-label]="'Go to media ' + (i + 1)">
                      @switch (m.kind) {
                        @case ('image') {
                          <img [src]="m.url" alt="" />
                        }
                        @case ('video') {
                          <div class="thumb-video">
                            <span>▶</span>
                          </div>
                        }
                      }
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
        <div class="col-md-6" >
          <div class="shop-detail-left ">
            <!-- <span class="badge badge-success">{{"sale4you.label.product.greenLabel" | translate}}</span>-->
            @if (productObj.discount!=null) {
              <span class="badge badge-success">{{'sale4you.label.discount' | translate}} : {{productObj.discount}}{{'sale4you.label.Percent' | translate}} </span>
            }
            <h2 class="padingTopFivePx">{{productObj.name}}</h2>
            <!--<h6 style="direction: rtl;"><strong><span class="mdi mdi-approval"></span> {{'sale4you.label.location' | translate}}</strong> - {{productObj.area}}</h6>-->
            <!--<p class="regular-price" *ngIf="productObj.price!=null"><i class="mdi mdi-tag-outline"></i> {{productObj.price}} price</p>-->
            @if (productObj.price!=null) {
              <p class="offer-price  padingButtomFivePx">{{'sale4you.label.price' | translate}} : <span class="text-success">{{productObj.price}}</span> </p>
            }
            <!-- <p class="offer-price  padingButtomFivePx" *ngIf="productObj.discount!=null">{{'sale4you.label.discount' | translate}} : <span class="text-success"> {{productObj.discount}}{{'sale4you.label.Percent' | translate}}</span> </p>-->
            <button type="button" class="btn btn-secondary btn-lg" (click)="addToWishList($event,productObj)"><i class='fas fa-cart-plus'></i> {{'sale4you.label.addToWishList' | translate}}</button>
            <!-- <p class="offer-price mb-0" *ngIf="productObj.discount!=null">price : <span class="text-success">{{productObj.price}} price</span></p>-->
            <div id="detailsTable" style="padding-top: 10px" >
              <div class="row TableDetails" >
                @for (item of tableDetailsList; track item) {
                  <div class="col itemTableDetails"  >
                    <div  [outerHTML]=" item | getValueItemProduct:productObj" ></div>
                  </div>
                }
              </div>
            </div>
            <div class="short-description">
              <h5 style="padding-right: 5px">
                {{'sale4you.label.quickOverview' | translate}}
                <p class="float-right">{{'sale4you.label.availability' | translate}}:  @if (productObj.deviceStatus) {
                  <span class="badge badge-success">{{'sale4you.label.availability.active' | translate}}</span>
                  }@if (!productObj.deviceStatus) {
                  <span class="badge-danger">{{'sale4you.label.availability.inactive' | translate}}</span>
                }</p>
              </h5>
              <p class="TextAlignRight" style="white-space: pre-line">{{productObj.description | localizedDescription}}</p>
            </div>
            <h6 class="mb-3 mt-4">{{"sale4you.label.whySale4you" | translate}}</h6>
            <div class="row">
              <div class="col-md-6">
                <div class="feature-box">
                  <i class="mdi fas fa-car-alt" style='color:white'></i>
                  <h6 class="text-info">{{"sale4you.label.freeDelivery" | translate}}</h6>
                  <p>{{"sale4you.label.freeDelivery.value" | translate}}</p>
                </div>
              </div>
              <div class="col-md-6">
                <div class="feature-box">
                  <i class="mdi far fa-handshake" style='color:white'></i>
                  <h6 class="text-info">{{"sale4you.label.Guarantee" | translate}}</h6>
                  <p>{{"sale4you.label.Guarantee.value" | translate}}</p>
                </div>
              </div>
            </div>
            <!-- <div class="short-description">
            <h5 class="quick-overview padingTopFivePx padingButtomFivePx">
              {{'sale4you.label.quickOverview' | translate}}
              <p class="float-right availability-tag">{{'sale4you.label.availability' | translate}}
                <span *ngIf="productObj.deviceStatus" class="badge badge-success">{{'sale4you.label.availability.active' | translate}}</span>
                <span *ngIf="!productObj.deviceStatus" class="badge-danger">{{'sale4you.label.availability.inactive' | translate}}</span>
              </p>
            </h5>
            <p class="statusdevceStyle">
              {{productObj.description}}
            </p>
          </div>-->
          <!--<h6 class="mb-3 mt-4">{{"sale4you.label.whySale4you" | translate}}</h6>
          <div class="row">
            <div class="col-md-6">
              <div class="feature-box">
                <i class='fas fa-truck-moving'></i>
                <h6 class="text-info">{{"sale4you.label.freeDelivery" | translate}}</h6>
                <p>{{"sale4you.label.freeDelivery.value" | translate}}</p>
              </div>
            </div>
            <div class="col-md-6">
              <div class="feature-box">
                <i class="mdi mdi-basket"></i>
                <h6 class="text-info">{{"sale4you.label.Guarantee" | translate}}</h6>
                <p>{{"sale4you.label.Guarantee.value" | translate}}</p>
              </div>
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</section>
}
<!--<app-best-offers></app-best-offers>-->

<!-- ── Related Products ─────────────────────────────────────── -->
@if (relatedProducts.length > 0) {
  <section class="related-section" dir="rtl">
    <div class="container">
      <h5 class="related-title">מודעות דומות</h5>
      <div class="related-scroll-wrap">
        <div class="related-track">
          @for (p of relatedProducts; track p) {
            <a
              class="related-card"
              [routerLink]="['/single', p.id]"
              >
              <div class="related-img-wrap">
                <img
                  [src]="p.images?.[0]?.image || 'assets/img/placeholder.png'"
                  [alt]="p.name"
                  class="related-img"
                  />
                </div>
                <div class="related-info">
                  <p class="related-name">{{ p.name }}</p>
                  @if (p.price) {
                    <p class="related-price">{{ p.price | number  }} ₪</p>
                  }
                </div>
              </a>
            }
          </div>
        </div>
      </div>
    </section>
  }
